import React, { useEffect } from "react";
import Layout from "../components/layout"
import SEO from "../components/seo"
import ContactForm from "../components/ContactForm/ContactForm"

const ContactPage = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
  <Layout>
    <SEO title="Contact Us" />
    <div className="section symbol-l border-bottom-0">
      <div className="container">
      
      
        <div className="wrapper c">
          <div className="content _50">
            <h2 className="section-title margin">Contact Us</h2>
            <p className="">
                  You can schedule an appointment with us using the Calendly widget.
                  Alternatively, you can also <a href="mailto:info@cognetiks.com">drop us an email</a> at info@cognetiks.com, and we will be sure to get back to you to answer any queries you have.
            </p>
              <p>
                If you prefer, you can use the contact form below to reach out to us:
              </p>
              <div className="card">
                <ContactForm />
              </div>
          </div>
          <div className="content _50">
            
            <div className="card">
              <div
                className="calendly-inline-widget"
                data-url="https://calendly.com/talk-to-sales-cognetiks/30min"
                style={{ minWidth: 320, height: 770 }}
              ></div>
            </div>
            
          </div>
          
        </div>
      </div>

      <div className="container">
        <h2 className="mt-5">Our Offices</h2>
        <div className="wrapper">
          <div className="content _50">
            {/* <div className="card"> */}
            <h3 className="feature-title">London</h3>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2478.5018310392898!2d-0.24474108406953102!3d51.5956930120644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876112c654d46ff%3A0x2d5783608c857431!2sCroft%20House%2C%2021%20Heritage%20Ave%2C%20London%20NW9%205EW!5e0!3m2!1sen!2suk!4v1650535228030!5m2!1sen!2suk"
              width="100%"
              height="300"
              title="London address"
              frameborder="0"
              style={{ border: "0" }}
              allowfullscreen=""
            ></iframe>
            {/* </div> */}
          </div>
          <div className="content _50">
            {/* <div className="card"> */}
            <h3 className="feature-title">Lagos</h3>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.56687676762!2d3.385313350566059!3d6.449610605437837!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8b1016859b43%3A0x4491961cb22b490b!2s29%20Marina%20Rd%2C%20Lagos%20Island%2C%20Lagos%2C%20Nigeria!5e0!3m2!1sen!2suk!4v1580939018972!5m2!1sen!2suk"
              width="100%"
              height="300"
              title="Lagos address"
              frameborder="0"
              style={{ border: "0" }}
              allowfullscreen=""
            ></iframe>
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  </Layout>
);
};
export default ContactPage
